// External libraries
import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

// UITK
import { UitkFakeInput } from "uitk-react-input";
import { UitkToolbar, UitkToolbarProps, ToolbarType } from "uitk-react-toolbar";
import { UitkFullscreenDialog, UitkDialogAnimationType } from "uitk-react-dialog";
import { UitkLink } from "uitk-react-link";

// Components
import { WizardDialogTrigger } from "./WizardDialogTrigger";
import { RoomPicker } from "./RoomPicker";

// Types
import { GuestDialogProps, GuestProps } from "../typings";

// Utils
import { Experiment, isVariantEnabled } from "src/components/utility/experiment";
import { locKeys } from "./l10n";

export const GuestDialog = (props: GuestDialogProps) => {
  const { formatText } = useLocalization();

  const dialogAttributes: UitkToolbarProps = {
    action: props.onDismiss,
    iconLabel: formatText(locKeys.cancelButton),
    header: formatText(locKeys.dialogTitle),
    type: ToolbarType.CLOSE,
  };

  return (
    <UitkFullscreenDialog className="GuestDialog" dialogShow animation={UitkDialogAnimationType.SLIDEUP}>
      <UitkToolbar {...dialogAttributes} action={props.onDismiss.bind(this, WizardDialogTrigger.GUESTPICKER)} />
      <RoomPicker {...props} />
    </UitkFullscreenDialog>
  );
};

export const GuestField = ({
  guestsVal,
  open,
  focusInput,
  invalid,
  componentWithJs,
  isMobile,
  context,
}: GuestProps) => {
  const { formatText } = useLocalization();
  const isWizardRedesignEnabled = isVariantEnabled(context, Experiment.Flex_Blossom_Wizard_Redesign);

  let name: string | undefined;
  let value = guestsVal;
  let classes = "guests-input";

  if (!componentWithJs) {
    name = "adults";
    value = "2";
    classes = "";
  }

  if (isWizardRedesignEnabled && isMobile) {
    return (
      <UitkLink onClick={open} ref={focusInput} id="destination-field">
        <div role="button">
          <div className="utik-grid uitk-cell uitk-type-right">{guestsVal}</div>
        </div>
      </UitkLink>
    );
  }

  return (
    <UitkFakeInput
      id="destination-field"
      name={name}
      label={formatText(locKeys.guests)}
      value={value}
      className={classes}
      icon="person"
      // invalid={invalid} // missing property in UitkFakeInput, https://jira.expedia.biz/browse/UDS-2220
      onClick={open}
      onChange={open}
      domRef={focusInput}
      aria-label={`${formatText(locKeys.guests)} ${value}`}
    />
  );
};
